// extracted by mini-css-extract-plugin
module.exports = {"container":"SpinnerModal_container__3a9dv"};